export default __webpack_public_path__ + "static/media/play_icon.9e7ceea8.svg";